// // routes
// import { paths } from 'src/routes/paths';
// // utils
// import axios from 'src/utils/axios';

// function jwtDecode(token: string) {
//   const base64Url = token.split('.')[1];
//   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//   const jsonPayload = decodeURIComponent(
//     window
//       .atob(base64)
//       .split('')
//       .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
//       .join('')
//   );

//   return JSON.parse(jsonPayload);
// }

// export const isValidToken = (accessToken: string) => {
//   if (!accessToken) {
//     return false;
//   }

//   const decoded = jwtDecode(accessToken);
//   const currentTime = Date.now() / 1000;
//   return decoded.exp > currentTime;
// };

// // ----------------------------------------------------------------------

// export const tokenExpired = (exp: number) => {
//   let expiredTimer;
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   clearTimeout(expiredTimer);

//   expiredTimer = setTimeout(() => {
//     // alert('Token expired');

//     sessionStorage.removeItem('accessToken');

//     window.location.href = paths.auth.jwt.login;
//   }, timeLeft);
// };


// export const setSession = (accessToken: string | null) => {
//   if (accessToken) {
//     // sessionStorage.setItem('accessToken', accessToken);
//     localStorage.setItem('accessToken', accessToken);

//    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
//     const { exp } = jwtDecode(accessToken);
//     tokenExpired(exp);
//   } else {
//     localStorage.removeItem('accessToken');

//     // sessionStorage.removeItem('accessToken');

//     delete axios.defaults.headers.common.Authorization;
//   }
// };



import { paths } from 'src/routes/paths';
import axios from 'src/utils/axios';

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken: string) => {
  if (!accessToken) return false;
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

let expiredTimer: ReturnType<typeof setTimeout>; // ✅ function ke bahar

export const tokenExpired = (exp: number) => {
  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    // ✅ localStorage — sessionStorage nahi
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user_id');
    window.location.href = paths.auth.jwt.login;
  }, timeLeft);
};

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken); // ✅ localStorage
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    const { exp } = jwtDecode(accessToken);
    tokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken');  // ✅ localStorage
    localStorage.removeItem('user_id');      // ✅ user_id bhi clean
    delete axios.defaults.headers.common.Authorization;
    clearTimeout(expiredTimer);              // ✅ timer bhi clear
  }
};